import {Header} from './Header/index';

export const Page = ({children, showProgress}) => {
    return(
        <div className='page'>
            <Header />
            <div className='page__content'>
                { children }
            </div>
            {showProgress === true &&
                <div className='progress-overlay'>
                    <div className="progress"></div>
                </div>
            }
        </div>
    )
}
